<template>
  <div role="alert" class="alert alert-info alert-icon alert-dismissible p-2 px-md-4">
    <div class="alert-content">
      A small charge will be applied for verification and refunded shortly. You may receive a one-time passcode (OTP); please keep it secure and do not share it outside this app.
    </div>
    <button aria-label="Close" class="close p-1" data-dismiss="alert" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'DisplayRefundAlert'
}
</script>
